import { t } from '@lingui/core/macro';
import { DialogHeader } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
export function Header() {
    return (<DialogHeader title={t({
            comment: 'Dashboard: send for e-signing modal - title',
            message: 'Send for e-signing',
        })} icon={<Falcon icon="pen-swirl"/>}/>);
}
